/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AgentFieldsBase {
    getFixupPrototypeFunction() { return AgentFieldsBase.fixupPrototype; }

    static newInstance(model: Partial<AgentFieldsBase>): AgentFieldsBase {
        let obj = Object.assign(new AgentFieldsBase(), model);
        AgentFieldsBase.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AgentFieldsBase>): AgentFieldsBase {
        if (!model) return null;
        return AgentFieldsBase.newInstance(<AgentFieldsBase> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AgentFieldsBase) {
        if (!obj) return;

        models.AgentFieldsBase.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AgentFieldsBase): boolean {
        Object.setPrototypeOf(obj, AgentFieldsBase.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (typeof this.created_at === "string") {
            this.created_at = new Date(<string><any>this.created_at);
        }
        if (typeof this.updated_at === "string") {
            this.updated_at = new Date(<string><any>this.updated_at);
        }
    }

    /**
     * Unique identifier for the document
     */
    sys_id: string;

    /**
     * Timestamp when the document was created
     */
    created_at: Date;

    /**
     * Timestamp when the document was last updated
     */
    updated_at: Date;

}
